import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import articleList from "./articles.json";
import gslList from "./gsl.json";
import { kebab2camel } from "./utils.js";

Vue.use(Router);

// defining children routes for articles
const articles = articleList.filter(a => a.online).map(a => ({
  path: a.path,
  component: () => import("./articles/" + kebab2camel(a.path) + ".vue"),
  props: { header: a.header }
}));

// defining children routes for grad school log
const gsl = gslList.filter(l => l.online).map(l => ({
  path: l.path,
  component: () => import("./gsl/" + kebab2camel(l.path) + ".vue"),
  props: { header: l.header }
}));

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/about"
    },
    {
      path: "/home",
      name: "home",
      component: Home
    },
    {
      path: "/research",
      name: "research",
      component: () => import("./views/Research.vue")
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
      path: "/gsl",
      name: "gsl",
      children: gsl.concat([
        {
          path: "list",
          component: () => import("./components/List.vue"),
          props: {
            list: gslList
          }
        }
      ]),
      component: () => import("./views/GSL.vue")
    },
    {
      path: "/articles",
      name: "articles",
      children: articles.concat([
        {
          path: "list",
          component: () => import("./components/List.vue"),
          props: {
            list: articleList
          }
        }
      ]),
      component: () => import("./views/Articles.vue")
    },
    {
      path: "*",
      name: "404",
      component: () => import("./views/404.vue")
    }
  ]
});
